import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  GetByIdProfessionalManagementUseCaseInterface,
  GetProfessionalOverviewUseCaseInterface,
} from 'domain/usecases';

interface IProfessionalOverviewState {
  selectedProfessionalData: GetByIdProfessionalManagementUseCaseInterface.Result;
  professionalOverviewData: GetProfessionalOverviewUseCaseInterface.Result;
}

interface IPayloadSelectedProfessionalData
  extends PayloadAction<GetByIdProfessionalManagementUseCaseInterface.Result> {}

interface IPayloadProfessionalOverview
  extends PayloadAction<GetProfessionalOverviewUseCaseInterface.Result> {}

const initialState: IProfessionalOverviewState = {
  selectedProfessionalData: null,
  professionalOverviewData: null,
};

export const ProfessionalOverviewSlice = createSlice({
  name: 'professional-overview',
  initialState,
  reducers: {
    loadSelectedProfessionalData: (
      state,
      action: IPayloadSelectedProfessionalData,
    ) => {
      state.selectedProfessionalData = action.payload;
    },
    clearSelectedProfessionalData: (state) => {
      state.selectedProfessionalData = null;
    },
    loadProfessionalOverviewData: (
      state,
      action: IPayloadProfessionalOverview,
    ) => {
      state.professionalOverviewData = action.payload;
    },
    clearProfessionalOverviewData: (state) => {
      state.professionalOverviewData = null;
    },
  },
});

export const {
  loadSelectedProfessionalData,
  clearSelectedProfessionalData,
  loadProfessionalOverviewData,
  clearProfessionalOverviewData,
} = ProfessionalOverviewSlice.actions;

export default ProfessionalOverviewSlice.reducer;
